/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Temsili_NoteInputs */

const tr_landing_temsili_note = /** @type {(inputs: Landing_Temsili_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Görsellerdeki ekran görüntüleri, veriler ve tutarlar temsilidir.`)
};

const en_landing_temsili_note = /** @type {(inputs: Landing_Temsili_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Screenshots, data and amounts shown are for illustration only.`)
};

const de_landing_temsili_note = /** @type {(inputs: Landing_Temsili_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildschirmfotos, Daten und Beträge in den Abbildungen sind Beispiele.`)
};

const ru_landing_temsili_note = /** @type {(inputs: Landing_Temsili_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Снимки экрана, данные и суммы на изображениях приведены в качестве примера.`)
};

/**
* | output |
* | --- |
* | "Screenshots, data and amounts shown are for illustration only." |
*
* @param {Landing_Temsili_NoteInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_temsili_note = /** @type {((inputs?: Landing_Temsili_NoteInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Temsili_NoteInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_temsili_note(inputs)
	if (locale === "de") return de_landing_temsili_note(inputs)
	if (locale === "ru") return ru_landing_temsili_note(inputs)
	return tr_landing_temsili_note(inputs)
});